import Swiper from 'swiper/bundle';

const ImageGalleryVideo = () => {
    const sliders = document.querySelectorAll('.image-gallery-video__swiper');

    if (!sliders.length) return;

    sliders.forEach(slider => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.image-gallery-video__swiper-wrapper');
        if (!swiperWrapper) return;

        // get the current slide for when updating the counter
        const currentSlide = slider.querySelector('.image-gallery-video__current');

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            pagination: false,
            navigation: {
                nextEl: slider.querySelector('.image-gallery-video__nav--next'),
                prevEl: slider.querySelector('.image-gallery-video__nav--prev'),
            },
            on: {
                init(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
                slideChange(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
            },
        });
    });
};

export default ImageGalleryVideo;
